module.exports = __webpack_public_path__ + "static/media/halona-picturemark-l.c0564885.svg";